import { apiClient } from './apiClient';
import type { ClientDiagnosticsEntry } from '../types/diagnostics';

export const adminDiagnosticsService = {
    async getClients(): Promise<ClientDiagnosticsEntry[]> {
        const response = await apiClient.get<ClientDiagnosticsEntry[]>('/diagnostics/clients');
        return response.data;
    },

    async getClient(userId: string): Promise<ClientDiagnosticsEntry> {
        const response = await apiClient.get<ClientDiagnosticsEntry>(`/diagnostics/clients/${userId}`);
        return response.data;
    },

    async forceServiceWorkerUpdate(userId: string): Promise<void> {
        await apiClient.post(`/diagnostics/clients/${userId}/force-sw-update`);
    },

    async forceServiceWorkerUpdateAll(): Promise<void> {
        await apiClient.post('/diagnostics/clients/force-sw-update-all');
    },
};
